export const parsePath = (path: string): Array<string | number> => {
  // Stödjer: a.b[0].c, a[0][1].b, a.0.b osv.
  const normalized = path
    .replace(/\[(\d+)\]/g, ".$1") // [0] -> .0
    .replace(/^\./, ""); // ta bort ev. ledande punkt

  return normalized
    .split(".")
    .filter(Boolean)
    .map((p) => {
      const n = Number(p);
      return Number.isInteger(n) && String(n) === p ? n : p;
    });
};

export const setByPath = (obj: any, path: string, value: unknown) => {
  const parts = parsePath(path);
  if (parts.length === 0) return;

  let cur = obj;

  for (let i = 0; i < parts.length - 1; i++) {
    const key = parts[i]!;
    const nextKey = parts[i + 1]!;
    const nextShouldBeArray = typeof nextKey === "number";

    if (cur[key as any] == null) {
      cur[key as any] = nextShouldBeArray ? [] : {};
    }

    cur = cur[key as any];
  }

  const last = parts[parts.length - 1]!;
  cur[last as any] = value;
};
